import { focus, minBreakpoints } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem, theme } from '@noths/polaris-client-styles';
import styled, { css } from 'styled-components';

const { colors } = theme;

export const RangeInputRail = styled.div`
  position: absolute;
  width: 100%;
  height: ${pxToRem(4)};
  border-radius: ${pxToRem(7)};
  cursor: pointer;
  background-color: #aebcc6;

  &::before {
    content: '';
    position: absolute;
    top: ${pxToRem(-3)};
    left: ${pxToRem(-3)};
    width: ${pxToRem(10)};
    height: ${pxToRem(10)};
    border-radius: ${pxToRem(8)};
    background-color: #aebcc6;
  }
  &::after {
    content: '';
    position: absolute;
    right: ${pxToRem(-3)};
    top: ${pxToRem(-3)};
    width: ${pxToRem(10)};
    height: ${pxToRem(10)};
    border-radius: ${pxToRem(8)};
    background-color: #aebcc6;
  }
`;

export const RangeInputWrapper = styled.div`
  height: ${pxToRem(100)};
  width: 100%;
  margin-top: ${pxToRem(50)};
`;

export const SliderWithStyles = styled.div`
  position: relative;
  margin: 0 ${pxToRem(16)};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin: 0 ${pxToRem(18)};
    `,
  )};

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      margin: 0 ${pxToRem(14)};
    `,
  )};
`;

interface RangeInputHandleWrapperProps {
  percent: number;
}

export const RangeInputHandleWrapper = styled.button.attrs(
  ({ percent }: RangeInputHandleWrapperProps) => ({
    style: {
      left: `${percent}%`,
    },
  }),
)<RangeInputHandleWrapperProps>`
  position: absolute;
  z-index: 2;
  transform: translate(-50%, -50%);
  width: ${pxToRem(36)};
  height: ${pxToRem(36)};
  cursor: pointer;
  background-color: transparent;
  border: solid ${pxToRem(2)} transparent;

  &::before {
    content: '';
    position: absolute;
    top: ${pxToRem(2)};
    left: ${pxToRem(2)};
    width: ${pxToRem(28)};
    height: ${pxToRem(28)};
    border: solid ${pxToRem(1)} ${colors.greySlate};
    border-radius: 50%;
    background-color: #ffffff;
  }

  &.focus-visible:focus {
    border-radius: 50%;
    ${focus};

    ${/* override default focus styles */ ''}
    box-shadow: none;
  }

  &[data-highlight='true'] {
    &::before {
      top: 0px;
      left: 0px;
      width: ${pxToRem(32)};
      height: ${pxToRem(32)};
      border: solid ${pxToRem(1)} transparent;
      background-color: ${colors.blueNavy};
    }

    &:focus {
      border: solid ${pxToRem(2)} transparent;
    }
  }
`;

interface RangeInputTrackProps {
  sourcePercent: number;
  targetPercent: number;
}

export const RangeInputTrack = styled.div.attrs(
  ({ sourcePercent, targetPercent }: RangeInputTrackProps) => ({
    style: {
      left: `${sourcePercent}%`,
      width: `${targetPercent - sourcePercent}%`,
    },
  }),
)<RangeInputTrackProps>`
  position: absolute;
  height: ${pxToRem(4)};
  z-index: 1;
  background-color: #021828;
  border-radius: ${pxToRem(7)};
  cursor: pointer;
  top: 0;
`;

// Negative position values needed as the text fields have been retrofitted into the
// slider library and have to sit next to the range handles in the markup.
export const RangeInputTextFieldsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  .range-input-text-field__wrapper {
    margin-top: ${pxToRem(38)};
    width: ${pxToRem(70)};
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    ${/* Disabled borders until text fields are re-enabled
      border-radius: ${pxToRem(6)};
      border: solid ${pxToRem(1)} #7b8a94;
      border-width: ${pxToRem(1)};
    */ ''};
    overflow: hidden;

    &:focus-within {
      outline: auto;
      outline-color: ${colors.blueNavy};
      outline-width: 2px;
      outline-offset: 2px;
    }
  }

  .range-input-text-field__input {
    min-width: 0;
    width: 100%;
    height: ${pxToRem(34)};
    text-align: center;
    border: 0;
    color: #021828;
    ${/* TODO: background not needed once text fields are re-enabled */ ''}
    background: ${colors.white};

    &:focus,
    &:active {
      outline: none;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  & input[type='number'] {
    -moz-appearance: textfield;
  }
`;

export const inputTextFieldPrefix = css`
  border-right: solid ${pxToRem(1)} #7b8a94;
  margin-left: ${pxToRem(8)};
  padding-right: ${pxToRem(8)};
`;
